/** THIS FILE MUST FOLLOW NODEJS SEMANTICS */

/** Template
const PageNameMeta = {
  path: "", // required, with leading and trailing forward slash
  title: "", // required
  description: "", // required
  external: false, // optional
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2022-01-15", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
  // socialImage not required
  socialImage: {
    src: "", // require("path/to/image.png")
    width: "100px",
    height: "100px",
  },
}
*/

const NotFoundMeta = {
  path: "/404/",
  title: "Oops! That page can't be found.",
  description: "",
}

const IndexMeta = {
  path: "/",
  title: "Slice Insurance",
  description:
    "Slice is the premier technology company for 100% digital, small business insurance. Backed by top global insurers and powered by advanced AI/ML and large language models, we offer seamlessly automated, online and hassle-free insurance solutions.",
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const SliceMindMeta = {
  path: "/slice-mind/",
  title: "Slice Mind",
  description:
    "Slice Mind and our Insurance Cloud Services (ICS) platform utilize AI, ML, behavioral science, and Large Language Models to deliver on-demand small business insurance products.",
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2024-01-28", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageCommercialRealEstateMeta = {
  path: "/industry/commercial-real-estate/", // required, with leading and trailing forward slash
  title: "Commercial Real Estate", // required
  description:
    "Comprehensive Commercial GL and Property Coverage on select commercial real estate exposures.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageContractorsMeta = {
  path: "/industry/contractors/", // required, with leading and trailing forward slash
  title: "Contractors", // required
  description:
    "Comprehensive Commercial GL coverage designed for artisans, general contractors and remodelers.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageHospitalityMeta = {
  path: "/industry/hospitality/", // required, with leading and trailing forward slash
  title: "Hospitality", // required
  description:
    "Comprehensive Commercial GL & Property Coverages designed for small to mid-size hospitality risks.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageRetailMeta = {
  path: "/industry/retail/", // required, with leading and trailing forward slash
  title: "Retail", // required
  description:
    "Comprehensive Commercial GL & Property Coverages designed for small to mid-size retail exposures.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageManufacturingMeta = {
  path: "/industry/manufacturing/", // required, with leading and trailing forward slash
  title: "Manufacturing", // required
  description:
    "Comprehensive Commercial GL & Property Coverages designed for select manufacturing exposures.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageContractorsGeneralLiabilitySmallBusinessMeta = {
  path: "/product/contractors-general-liability-small-business/", // required, with leading and trailing forward slash
  title: "Contractors GL - Small Business", // required
  description:
    "Comprehensive coverage designed for small business artisans, general contractors and remodelers.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageContractorsGeneralLiabilityMidMarketMeta = {
  path: "/product/contractors-general-liability-mid-market/", // required, with leading and trailing forward slash
  title: "Contractors GL - Mid-Market", // required
  description:
    "Comprehensive coverage designed for mid-market artisans, general contractors and remodelers.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageEnvironmentalOverviewMeta = {
  path: "/product/environmental-overview/", // required, with leading and trailing forward slash
  title: "Environmental Overview", // required
  description:
    "Environmental Liability Insurance designed with greater security and flexibility for our policyholders.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageExcessCasualtyMeta = {
  path: "/product/excess-casualty/", // required, with leading and trailing forward slash
  title: "Excess Casualty", // required
  description:
    "Excess Casualty Coverage designed for Contracting, Hospitality, Manufacturing, Retail, and Real Estate industries.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageLessorsRiskMeta = {
  path: "/product/lessors-risk/", // required, with leading and trailing forward slash
  title: "Lessor’s Risk", // required
  description:
    "Flexible Lessor’s Risk coverage with low minimum premiums, broad occupancy, and key enhancements.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageMonolinePropertyMeta = {
  path: "/product/monoline-property/", // required, with leading and trailing forward slash
  title: "Monoline Property", // required
  description:
    "Monoline Property coverage available with $5K minimums and eligibility up to $50K in premium.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageOwnersInterestMeta = {
  path: "/product/owners-interest/", // required, with leading and trailing forward slash
  title: "Owner’s Interest", // required
  description:
    "Coverage for property owners for liability during construction with Owner’s Interest.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CoverageVacantBuildingsMeta = {
  path: "/product/vacant-buildings/", // required, with leading and trailing forward slash
  title: "Vacant Buildings", // required
  description:
    "Vacant Property coverage for heightened risks of unoccupied buildings with specialized protection.", // required
  // sitemap only required if this page should be listed on the sitemap
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const AgentsMeta = {
  path: "/agents/",
  title: "Agents",
  description:
    "Experience 100% digital small business insurance. Seamlessly automated, online, and hassle-free. Create your account or log in to access Slice.", // required
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2023-04-05", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const MobilityMeta = {
  path: "/mobility-insurance/",
  title: "Mobility Insurance",
  description:
    "Mobility insurance technology supporting safer driving and better protection for vehicles and drivers.", // required
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2022-01-21", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const AboutMeta = {
  path: "/about/",
  title: "About Us",
  description:
    "As a forward-thinking technology and insurance company, we fill protection gaps for small businesses through innovative, transparent products and a cloud-based platform, leveraging artificial intelligence, machine learning, and large language models.", // required
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2025-04-27", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const CareersMeta = {
  path: "/careers/",
  title: "Careers",
  description:
    "Explore career opportunities with Slice and be a part of shaping and innovating insurance.",
  sitemap: {
    priority: 0.7,
    changeFrequency: "yearly",
    lastModified: "2022-01-27",
  },
}

const PressMediaMeta = {
  path: "/press-media/",
  title: "Media",
  description:
    "Stay up-to-date about the latest developments at Slice through our media coverage and podcasts.", // required
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2023-04-05", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const ContactMeta = {
  path: "/contact/",
  title: "Contact",
  description: "Reach out to Slice Labs with any questions or comments.", // required
  sitemap: {
    priority: 0.7, // page priority weight, 0.0 - 1.0
    changeFrequency: "yearly", // one of: always, hourly, daily, weekly, monthly, yearly, never
    lastModified: "2022-01-22", // MUST be in YYYY-MM-DD format, make sure to update when changing content
  },
}

const LicenseNumbersMeta = {
  path: "/license-numbers/",
  title: "Slice License Numbers",
  description:
    "View our United States license numbers to ensure transparency and trust.",
  sitemap: {
    priority: 0.1,
    changeFrequency: "yearly",
    lastModified: "2022-01-23",
  },
}

const PrivacyMeta = {
  path: "/privacy-policy/",
  title: "Privacy Policy",
  description:
    "Understand how Slice handles your data by reviewing our Privacy Policy.",
  sitemap: {
    priority: 0.5,
    changeFrequency: "yearly",
    lastModified: "2022-01-26",
  },
}

const TermsMeta = {
  path: "/terms-of-use/",
  title: "Terms of Use",
  description:
    "Familiarize yourself with the terms governing your use of Slice's services.",
  sitemap: {
    priority: 0.5,
    changeFrequency: "yearly",
    lastModified: "2022-01-28",
  },
}

const CookieMeta = {
  path: "/cookie-policy/",
  title: "Cookie Policy",
  description:
    "Learn about the cookies used on Slice's website and their purpose.",
  sitemap: {
    priority: 0.5,
    changeFrequency: "yearly",
    lastModified: "2022-01-28",
  },
}

const SitemapMeta = {
  path: "/sitemap/",
  title: "Sitemap",
  description: "Explore the structure of Slice's website.",
  sitemap: {
    priority: 0.5,
    changeFrequency: "yearly",
    lastModified: "2023-04-05",
  },
}

const FaqMeta = {
  path: "/faq/",
  title: "FAQs",
  description:
    "Get answers to common queries about Slice’s products and services.",
  sitemap: {
    priority: 0.5,
    changeFrequency: "yearly",
    lastModified: "2022-06-02",
  },
}

const BlogMeta = {
  path: "https://blog.sliceinsurance.com",
  title: "Blog",
  description: "Slice's blog page",
  external: true,
}

const AgentPlatformMeta = {
  path: "https://app.sliceinsurance.com/e62c64fd-f0d5-4e2e-915b-20c4f04c1a53/landing?ref_agent_id=e62c64fd-f0d5-4e2e-915b-20c4f04c1a53",
  title: "Agent Platform",
  description: "",
  external: true,
}

const Sitemap = {
  Main: [
    IndexMeta,
    SliceMindMeta,
    AgentsMeta,
    ContactMeta,
    SitemapMeta,
    AgentPlatformMeta,
  ],
  Corporate: [AboutMeta, CareersMeta, PressMediaMeta, BlogMeta, FaqMeta],
  Product: [
    CoverageContractorsGeneralLiabilitySmallBusinessMeta,
    CoverageContractorsGeneralLiabilityMidMarketMeta,
    CoverageEnvironmentalOverviewMeta,
    CoverageExcessCasualtyMeta,
    CoverageLessorsRiskMeta,
    CoverageMonolinePropertyMeta,
    CoverageOwnersInterestMeta,
    CoverageVacantBuildingsMeta,
  ],
  Industry: [
    CoverageCommercialRealEstateMeta,
    CoverageContractorsMeta,
    CoverageHospitalityMeta,
    CoverageRetailMeta,
    CoverageManufacturingMeta,
  ],
  Legal: [LicenseNumbersMeta, PrivacyMeta, TermsMeta, CookieMeta],
}

module.exports = {
  NotFoundMeta,
  IndexMeta,
  SliceMindMeta,
  CoverageCommercialRealEstateMeta,
  CoverageContractorsMeta,
  CoverageHospitalityMeta,
  CoverageRetailMeta,
  CoverageManufacturingMeta,
  CoverageContractorsGeneralLiabilitySmallBusinessMeta,
  CoverageContractorsGeneralLiabilityMidMarketMeta,
  CoverageEnvironmentalOverviewMeta,
  CoverageExcessCasualtyMeta,
  CoverageLessorsRiskMeta,
  CoverageMonolinePropertyMeta,
  CoverageOwnersInterestMeta,
  CoverageVacantBuildingsMeta,
  AboutMeta,
  MobilityMeta,
  LicenseNumbersMeta,
  ContactMeta,
  PressMediaMeta,
  AgentsMeta,
  PrivacyMeta,
  SitemapMeta,
  CareersMeta,
  CookieMeta,
  TermsMeta,
  FaqMeta,
  BlogMeta,
  AgentPlatformMeta,
  Sitemap,
}
